import type { Generation } from './api'

interface ShareResult {
  shared: boolean
  method: 'native' | 'clipboard'
}

export function canShare(): boolean {
  return typeof navigator.share === 'function'
}

export async function shareGeneration(
  generation: Generation,
): Promise<ShareResult> {
  const url = generation.r2_url ?? `${window.location.origin}/gallery#${generation.id}`
  const title = `FRANKENVIBES LAB — ${generation.prompt.slice(0, 60)}`
  const text = `Check out this AI-generated ${generation.type}: "${generation.prompt}"`

  if (canShare()) {
    try {
      await navigator.share({ title, text, url })
      return { shared: true, method: 'native' }
    } catch (err) {
      if ((err as DOMException).name === 'AbortError') {
        return { shared: false, method: 'native' }
      }
    }
  }

  await navigator.clipboard.writeText(url)
  return { shared: true, method: 'clipboard' }
}

export async function downloadGeneration(
  generation: Generation,
): Promise<void> {
  if (!generation.r2_url) return

  const response = await fetch(generation.r2_url)
  const blob = await response.blob()
  const extension = generation.type === 'video' ? 'mp4' : 'png'
  const filename = `frankenvibes-${generation.id.slice(0, 8)}.${extension}`

  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}
